import React, { Component } from 'react';
import TaxAuthorityStep2Page from './tax-authority-step2-html';
class TaxAuthorityStep2 extends Component {
    constructor(props) {
        super(props)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    render() {
        return (
            <div>
                <TaxAuthorityStep2Page
                />
            </div>
        )
    }
}
export default TaxAuthorityStep2;